// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

var state = false;
var pos;

$('.js-drawer').click(function() {
  $('html').toggleClass('is-open');
  // $(".js-drawer").toggleClass("is-active");

  if (state == false) {
      pos = $(window).scrollTop();
      $('body').addClass('is-fixed').css({'top': -pos});
      state = true;
    } else {
      $('body').removeClass('is-fixed').css({'top': 0});
      window.scrollTo(0, pos);
      state = false;
    }
})

$(".js-overlay").click(function() {
  if($('html').hasClass('is-open')){
    $('html').removeClass('is-open');
    $('body').removeClass('is-fixed').css({'top': 0});
    window.scrollTo(0, pos);
    state = false;
  }
})
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();
    mm.add("(min-width: 768px)", () => {
      gsap.utils.toArray(".js-img").forEach((target) => {  
        gsap.timeline({
          scrollTrigger: {
            trigger: target,
            start: "top 70%",
            end: "bottom center",
            // toggleActions: "play none none reverse",
            // markers: true,
          }
        })
        .fromTo(target,{
          opacity: 0,
          yPercent: 15,
        },
        {
          opacity: 1,
          yPercent: 0,
        })
        gsap.fromTo(target.querySelector('img'), {
          yPercent: 0,
        }, {
          yPercent: -30,
          scrollTrigger: {
            trigger: target,
            start: "top center",
            end: "bottom center",
            scrub: true,
          }
        }); 
      });

      // const scrollLine = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: ".js-target",
      //     start: "top 30%",
      //     end: "bottom bottom",
      //     scrub: true, 
      //   },
      // });
      const tl = gsap.timeline(
        {
          scrollTrigger: {
            trigger: ".js-trigger",
            start: "top 70%",
            end: "bottom bottom",
            // markers: true,
          }
        }
      );
      tl.to('.js-x-line', { width: '100%', duration: 1.3, })
      .to('.js-y-line', { height: '100%', duration: 1.3, },'>');

    });
    mm.add("(max-width: 767px)", () => {
      gsap.utils.toArray(".js-img").forEach((target) => {  
        gsap.timeline({
          scrollTrigger: {
            trigger: target,
            start: "top 70%",
            end: "bottom center",
            // toggleActions: "play none none reverse",
            // markers: true,
          }
        })
        .fromTo(target,{
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
        })
        gsap.fromTo(target.querySelector('img'), {
          y: 0,
        }, {
          y: -5,
          scrollTrigger: {
            trigger: target,
            start: "top center",
            end: "bottom center",
            scrub: true,
          }
        }); 
      });  
    });


    const items = gsap.utils.toArray(".js-parallax-img");

    items.forEach((item) => {
      gsap.fromTo(
        item.querySelector("img"), // アニメーションを適用する画像要素を取得
        {
          yPercent: 0, // パララックス前の要素の位置
        },
        {
          yPercent: -20, // 上に要素の幅の1/5分移動
          ease: "none", // イージングなし
          scrollTrigger: {
            trigger: item, // アニメーションのトリガー要素
            start: "top bottom", // アニメーション開始位置
            end: "bottom top", // アニメーション終了位置
            scrub: 1, // 動作を遅らせる
          },
        }
      );
    });

    gsap.utils.toArray(".js-text").forEach((target) => {  
      gsap.timeline({
        scrollTrigger: {
          trigger: target,
          start: "top 50%",
          end: "bottom center",
          // toggleActions: "play none none reverse",
          // markers: true,
        }
      })
      .fromTo(target,{
        opacity: 0,
        yPercent: 10,
      },
      {
        opacity: 1,
        yPercent: 0,
      })
    });
  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      console.log("a");
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper-parts', {
      speed: 5000,
      spaceBetween: 10,
      slidesPerView: 1.6,
      allowTouchMove: false,
      loop: true,
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 3.5,
        }
      }
    })
    const swiperInterview = new Swiper('.c-swiper-interview', {
      speed: 800,
      spaceBetween: 110,
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
      loop: false,
      // autoplay: {
      //   delay: 5000,  
      // },
      paginationClickable: true,
      navigation: {
        prevEl: ".c-swiper-interview__prev",
        nextEl: ".c-swiper-interview__next"
      },
      breakpoints: {
        768: {
          slidesPerView: 1.2,
        }
      }
    })
    const swiperMv = new Swiper('.c-swiper-mv', {
      speed: 5000,
      slidesPerView: 1,
      effect: 'fade',
      allowTouchMove: false,
      loop: true,
      autoplay: {
        delay: 4000,  
        disableOnInteraction: false,
      },
    })
    const swiperImg = new Swiper('.c-swiper-img', {
      slidesPerView: 1,
      autoplay: {
        delay: 5000,  
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      // paginationClickable: true,
    })

    const swiperThum = new Swiper('.c-swiper-thum', {
      speed: 5000,
      spaceBetween: 10,
      slidesPerView: 1.1,
      allowTouchMove: false,
      loop: true,
      touchEventsTarget: 'wrapper',
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 2.5,
        }
      }
    })

    const swiperLoop = new Swiper('.c-swiper-loop', {
      speed: 5000,
      spaceBetween: 10,
      slidesPerView: 1.1,
      allowTouchMove: false,
      loop: true,
      touchEventsTarget: 'wrapper',
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          allowTouchMove: true,
          spaceBetween: 20,
          slidesPerView: 2.5,
          autoplay: 500,
        }
      }
    })

    $(window).on('load resize', function() {
      var windowWidth = $(window).width();
      if (windowWidth <= 768) {
        swiperLoop.startAutoplay();
      } else {
        swiperLoop.stopAutoplay();
      } 
    });
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class CreateLink {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
      //横幅768px以下（スマホ）に適用させるJavaScriptを記述
      const linkSp = document.createElement('span');
      const ulSp = document.getElementById('pgc-941-4-0');
      linkSp.innerHTML = '<a href="https://dept.dokkyomed.ac.jp/dep-m/kensyui-boshu/index.php#!page2" target="_blank" class="createLink">' + '</a>'
      ulSp.appendChild(linkSp);
    } else {
      //横幅768px以上（PC、タブレット）に適用させるJavaScriptを記述
      const link = document.createElement('span');
      const ul = document.querySelector('.so-widget-sow-image-default-c67d20f9f743-941');
      link.innerHTML = '<a href="https://dept.dokkyomed.ac.jp/dep-m/kensyui-boshu/index.php#!page2" target="_blank" class="createLink">' + '</a>'
      ul.appendChild(link);
    }
  }
}
class GridEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
    //横幅768px以下（スマホ）に適用させるJavaScriptを記述
    $(function () {
      // liの数を取得
      const listItems = $(".js-grid li").length;
      $(".js-grid").each(function () {
        // 最初に表示させるliの数
        let num = 6,
          // 閉じた時に表示させるliの数
          closeNum = num - 1;
        // 最初はもっと見るボタン表示、閉じるボタン非表示
        $(this).find(".js-more").show();
        $(this).find(".js-close").hide();
        // 5行目まで表示
        $(this)
          .find("li:not(:lt(" + num + "))")
          .hide();
        // もっと見るボタンがクリックされた時
        $(".js-more").click(function () {
          // numに+5ずつしていく = 5行ずつ追加する
          num += 4;
          $(this)
            .parent()
            .find("li:lt(" + num + ")")
            .slideDown();
          // liの数よりnumが多い時、
          if (listItems <= num) {
            // もっと見るボタン非表示
            $(".js-more").hide();
            // 閉じるボタン表示
            $(".js-close").show();
            // 閉じるボタンがクリックされたら、
            $(".js-close").click(function () {
              $(this)
                .parent()
                .find("li:gt(" + closeNum + ")")
                // 6行目以降は非表示
                .slideUp();
              // 閉じるボタンを非表示
              $(this).hide();
              // もっと見るボタン表示に
              $(".js-more").show();
            });
          }
        });
      });
    });
    } else {
      $(function () {
        // liの数を取得
        const listItems = $(".js-grid li").length;
        $(".js-grid").each(function () {
          // 最初に表示させるliの数
          let num = 9,
            // 閉じた時に表示させるliの数
            closeNum = num - 1;
          // 最初はもっと見るボタン表示、閉じるボタン非表示
          $(this).find(".js-more").show();
          $(this).find(".js-close").hide();
          // 5行目まで表示
          $(this)
            .find("li:not(:lt(" + num + "))")
            .hide();
          // もっと見るボタンがクリックされた時
          $(".js-more").click(function () {
            // numに+5ずつしていく = 5行ずつ追加する
            num += 6;
            $(this)
              .parent()
              .find("li:lt(" + num + ")")
              .slideDown();
            // liの数よりnumが多い時、
            if (listItems <= num) {
              // もっと見るボタン非表示
              $(".js-more").hide();
              // 閉じるボタン表示
              $(".js-close").show();
              // 閉じるボタンがクリックされたら、
              $(".js-close").click(function () {
                $(this)
                  .parent()
                  .find("li:gt(" + closeNum + ")")
                  // 6行目以降は非表示
                  .slideUp();
                // 閉じるボタンを非表示
                $(this).hide();
                // もっと見るボタン表示に
                $(".js-more").show();
              });
            }
          });
        });
      });
    }
  }
}
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let gridEvent = new GridEvent('js-grid');
  let createLink = new CreateLink('so-widget-sow-image-default-c67d20f9f743-941');

  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
  let top = new Top('p-top');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });